import { FC, useContext } from "react";
import { Card, Col, Row } from "antd";
import Text from "antd/lib/typography/Text";
import Paragraph from "antd/lib/typography/Paragraph";
import "./styles.less";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import dynamic from "next/dynamic";

interface SubsidiaryProps {
	id: string;
	name: string;
	address: string;
	officeHours: string;
}

export const Subsidiary: FC<SubsidiaryProps> = ({
	id,
	name,
	address,
	officeHours
}) => {
	const { country_code } = useContext(ConfigStateContext);

	return (
		<Card key={id} size={"small"} className="subsidiary">
			<Row gutter={16} align={"middle"}>
				{country_code !== "CO" && (
					<Col flex={1} className="center">
						<Text strong className="title">
							{name}
						</Text>
						<Paragraph
							className="paragraph"
							ellipsis={
								country_code === "ce3"
									? false
									: { rows: 1, expandable: false, symbol: "Más" }
							}>
							{address}
						</Paragraph>
						<Text type={"secondary"} className={"hours"}>
							{officeHours}
						</Text>
					</Col>
				)}
				{/* <Col style={{ margin: "auto" }}>
					{country_code !== "BR" && (
						<Space size={4}>
							<div className="phone-button-subsidiary">
								<PhoneButton
									id={propertyId}
									type="viewPhone"
									mode={mode}
									icon
									btnType="text"
									disabled={disabled}
									owner={owner}
									isProject={isProject}
								/>
							</div>
						</Space>
					)}
				</Col> */}
			</Row>
		</Card>
	);
};

